module.exports = __webpack_public_path__ + "static/media/home-changing-1.61598fa9.jpg";